// extracted by mini-css-extract-plugin
module.exports = {"PROBANDO":"Cards_PROBANDO__2q29J","Card":"Cards_Card__2_8TI","btnAdmin":"Cards_btnAdmin__2TgHr"};